export default "__VITE_ASSET__Bg8MGh4g__"